<!-- Header microempresario v2 — activo en todo el perfil / sesión micro -->
<header class="micro-header-v2" role="banner">
  <div class="micro-header-v2__bar">
    <div class="micro-header-v2__inner">
      <a
        class="micro-header-v2__logo"
        routerLink="/microempresario/home"
        aria-label="Ir al inicio de microempresario"
      >
        <img
          src="assets/img/Home/svg/logo-neocredito-header.svg"
          alt="neocrédito"
          class="micro-header-v2__logo-img"
          width="172"
          height="28"
        />
      </a>

      <div class="micro-header-v2__session-info" aria-label="Información de sesión">
        <p class="micro-header-v2__session-line">
          <strong>Ip:</strong> {{ ip || '—' }}
        </p>
        <p class="micro-header-v2__session-line">
          <strong>Último acceso:</strong>
          {{ ultimaConexion ? (ultimaConexion | date: "dd/MM/yyyy, hh:mm") : '—' }}
        </p>
        <p class="micro-header-v2__session-line">
          <span class="fas fa-calendar-day" aria-hidden="true"></span>
          {{ dia }}, {{ fecha }}
        </p>
        <p class="micro-header-v2__session-line">
          <span class="fas fa-clock" aria-hidden="true"></span>
          {{ hora }}:{{ minutos }}:{{ segundos }} {{ ampm }}
        </p>
      </div>

      <div class="micro-header-v2__user dropdown">
        <button
          class="micro-header-v2__user-btn"
          type="button"
          id="microHeaderUserMenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          aria-haspopup="true"
        >
          <span class="micro-header-v2__user-name">{{ userName }}</span>
          <svg
            class="micro-header-v2__user-chevron"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <ul class="dropdown-menu dropdown-menu-end micro-header-v2__menu" aria-labelledby="microHeaderUserMenu">
          <li>
            <a class="dropdown-item" routerLink="/microempresario/actualizar-datos">Actualizar datos</a>
          </li>
          <li>
            <a class="dropdown-item" routerLink="/microempresario/deshabilitar-usuario">Deshabilitar usuario</a>
          </li>
          <li>
            <a class="dropdown-item" routerLink="/microempresario/cambiar-contrasena">Cambiar contraseña</a>
          </li>
          <li>
            <button type="button" class="dropdown-item" (click)="getModal()">Desuscribir notificaciones</button>
          </li>
          <li>
            <button type="button" class="dropdown-item" (click)="closeSession()">Cerrar sesión</button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="micro-header-v2__accent" aria-hidden="true">
    <span class="micro-header-v2__accent-segment micro-header-v2__accent-segment--1"></span>
    <span class="micro-header-v2__accent-segment micro-header-v2__accent-segment--2"></span>
    <span class="micro-header-v2__accent-segment micro-header-v2__accent-segment--3"></span>
  </div>
</header>

<!--
  ============================================================================
  HEADER ANTERIOR (comentado — no eliminar todavía)
  Se activaba con skin distinto de v2. Conservar por si hay rollback.
  ============================================================================
  <div class="header">
    <div class="container-fluid">
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-lg-7">
            <img
              routerLink="/microempresario/home"
              class="logo"
              src="assets/img/logo.svg"
              alt="Logo neocredito"
              />
            </div>
            <div
              class="col-lg-5 d-flex flex-row justify-content-end align-items-center"
              >
              <div class="data-info me-5 text-lg-end">
                <p style="margin: 0"><strong>Ip: </strong>{{ ip }}</p>
                <p style="margin: 0">
                  <strong>Último acceso:</strong>
                  {{ ultimaConexion | date: "dd/MM/yyyy, hh:mm" }}
                </p>
                <p style="margin: 0">
                  <span class="fas fa-calendar-day"></span> {{dia}}, {{fecha}}
                </p>
                <p style="margin: 0">
                  <span class="fas fa-clock"></span> {{hora}}:{{minutos}}:{{segundos}} {{ampm}}
                </p>
              </div>
              <div class="iconlogim">
                <img src="assets/img/Ico_1.png" />
                <div class="control">
                  <h5>{{ userName }}</h5>
                  <div class="dropdown">
                    <a
                      class="nav-link dropdown-toggle p-0 m-0 menu_interno-dropdown"
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      >
                      Perfil
                    </a>
                    <div
                      class="dropdown-menu dropdown-menu-right"
                      style="width: 14rem !important"
                      aria-labelledby="dropdownMenuLink"
                      >
                      <a class="dropdown-item" routerLink="/microempresario/actualizar-datos" href="#">Actualizar datos</a>
                      <a class="dropdown-item" routerLink="/microempresario/deshabilitar-usuario" href="#">Deshabilitar usuario</a>
                      <a class="dropdown-item" routerLink="/microempresario/cambiar-contrasena">Cambiar contraseña</a>
                      <a class="dropdown-item" (click)="getModal()" style="cursor: pointer;">Desuscribir notificaciones</a>
                      <a class="dropdown-item" (click)="closeSession()" style="cursor: pointer;">Cerrar sesión</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-block d-lg-none">
          <div class="row">
            <img routerLink="/microempresario/home" class="logo" src="assets/img/logo.svg" alt="Logo neocredito" />
          </div>
          <div class="row">
            <div class="col-6">
              <p style="margin: 0; font-size: 0.8rem"><strong>Ip: </strong>{{ ip }}</p>
              <p style="margin: 0; font-size: 0.8rem"><strong>Último acceso:</strong> {{ ultimaConexion | date: "dd/MM/yyyy, hh:mm" }}</p>
              <p style="margin: 0; font-size: 0.8rem"><span class="fas fa-calendar-day"></span> {{dia}}, {{fecha}}</p>
              <p style="margin: 0; font-size: 0.8rem"><span class="fas fa-clock"></span> {{hora}}:{{minutos}}:{{segundos}} {{ampm}}</p>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <div class="control">
                <img src="assets/img/Ico_1.png" class="mb-1" />
                <h5 style="font-size: 1rem; font-weight: bold">{{ userName }}</h5>
                <div class="dropdown">
                  <a class="nav-link dropdown-toggle p-0 m-0 menu_interno-dropdown" href="#" role="button" id="dropdownMenuLinkMobile" data-bs-toggle="dropdown" aria-expanded="false">Perfil</a>
                  <div class="dropdown-menu dropdown-menu-right" style="width: 12rem !important" aria-labelledby="dropdownMenuLinkMobile">
                    <a class="dropdown-item" routerLink="/microempresario/actualizar-datos" href="#">Actualizar datos</a>
                    <a class="dropdown-item" routerLink="/microempresario/deshabilitar-usuario" href="#">Deshabilitar usuario</a>
                    <a class="dropdown-item" routerLink="/microempresario/cambiar-contrasena">Cambiar contraseña</a>
                    <a class="dropdown-item" (click)="getModal()" style="cursor: pointer;">Desuscribir notificaciones</a>
                    <a class="dropdown-item" (click)="closeSession()" style="cursor: pointer;">Cerrar sesión</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
-->

<!-- modal notificaciones -->
<div class="modal fade" id="modal-notificaciones" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editModalLabel">Desuscribir notificaciones</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

        </button>
      </div>
      <form [formGroup]="notificacionForm">
        <div class="modal-body m-1">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
              <div class="mb-3 required form-label"
                [ngClass]="{'is-invalid':validateField('habilitarCorreos')}">
                <label for="habilitarCorreos" style="color: black;">¿Deseas volver a recibir notificaciones?*</label>
                <div class="col-sm">
                  <div class="form-check form-check-inline ms-4"
                    [ngClass]="{'is-invalid':validateField('habilitarCorreos')}">
                    <input [value]="true" type="radio" class="form-check-input"
                      formControlName="habilitarCorreos" name="habilitarCorreos" [ngClass]="{'is-invalid':validateField('habilitarCorreos')}"/>
                      <label for="habilitarCorreos" style="color: black !important;" class="form-check-label">Sí</label>
                    </div>
                    <div class="form-check form-check-inline ms-4"
                      [ngClass]="{'is-invalid':validateField('habilitarCorreos')}">
                      <div class="ms-4">
                        <input [value]="false" type="radio" class="form-check-input"
                          formControlName="habilitarCorreos" name="habilitarCorreos" [ngClass]="{'is-invalid':validateField('habilitarCorreos')}"/>
                          <label for="habilitarCorreos" style="color: black !important;" class="form-check-label">No</label>
                        </div>
                      </div>
                      <div class="invalid-feedback">Campo obligatorio</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                @if (notificacionForm.get('habilitarCorreos').value === false) {
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12"
                    >
                    <p>Lamentamos que no quieras recibir más información de la plataforma, ¿Estas seguro que quieres dejar de recibir notificaciones desde neocrédito?</p>
                  </div>
                }
              </div>
            </div>
          </form>
          <div class="modal-footer col-12 col-lg-12">
            <button type="submit" id="btn-aceptar" class="btn btn-primary hvr-shrink"
              [disabled]="notificacionForm.invalid" (click)="saveNotificacion()">
            Aceptar</button>
            <button type="button" id="btn-cancelar" class="btn btn-primary hvr-shrink" data-bs-dismiss="modal">
            Cancelar</button>
          </div>
        </div>
      </div>
    </div>
